export default __webpack_public_path__ + "static/birds-f50f349b50fb59e6b12df731055537ee.png";